
export function myPostListGet(page) {
	return {
    type: 'MY_POST_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export function myPostItemGet(postId, callback) {
	return {
    type: 'MY_POST_ITEM_GET',
		payload: {
			postId: postId,
		},
		callback: callback,
	}
}

export function myPostDateCheck(date, postId, callback) {
	return {
    type: 'MY_POST_DATE_CHECK',
		payload: {
			date: date,
			postId: postId,
		},
		callback: callback,
	}
}

export function myPostSave(data, callback) {
	return {
    type: 'MY_POST_SAVE',
		payload: data,
		callback: callback,
	}
}

export function myPostPhotoDel(postId, postPhotoId, callback) {
	return {
    type: 'MY_POST_PHOTO_DEL',
		payload: {
			postId: postId,
			postPhotoId: postPhotoId,
		},
		callback: callback,
	}
}


export function myPostDel(postId) {
	return {
    type: 'MY_POST_DEL',
		payload: {
			postId: postId,
		},
	}
}
